import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { FormikProvider, useFormik } from "formik";
import { useState } from "react";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import "./ModalCreatePurchaseOrder.scss";
import { IPurchaseOrder } from "../../../../types/purchaseOrder.types";
import * as Yup from "yup";
import { updatePurchaseOrder } from "../../../../common/services/purchaseOrder.api";
import EditFormItens from "../form/EditFormItens";
import FormEditInstalments from "../form/FormEditInstalments";

type Props = {
  onClose: (data: IPurchaseOrder) => void
  purchaseOrder: IPurchaseOrder
}

const createSchema = () => {

  const componentsPieceLength = window.document.querySelectorAll('#componentProduct').length;
  const componentsInstalmentLength = window.document.querySelectorAll('#instalment').length;

  const objValidationComponentsPiece = {
  };

  new Array(componentsPieceLength).fill(null).map((_, i) => {
    objValidationComponentsPiece[`item${i}`] = Yup.mixed().required('Item é obrigatório');
    objValidationComponentsPiece[`qtd${i}`] = Yup.number().required('Quantidade do item é obrigatório')
      .test('valida-qtd', 'Quantidade inválido', value => value > 0);
    objValidationComponentsPiece[`value${i}`] = Yup.string().required('Valor é obrigatório')
      .test('valida-value', 'Valor tem que ser maior que 0', value => parseFloat(value.replace(/[^\d,.-]/g, '').replace(',', '.')) > 0)
  });

  new Array(componentsInstalmentLength).fill(null).map((_, i) => {
    objValidationComponentsPiece[`expectedDate${i}`] = Yup.string().required('Data da primeira parcela é obrigatório')
  });

  return Yup.object().shape(objValidationComponentsPiece);
}

export default function ModalEditSubTable(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [loading, setLoading] = useState(false);
  const handleCloseModal = (data = props.purchaseOrder) => { props.onClose && props.onClose(data) };
  const [qtdInstalment, setQtdInstalment] = useState(props.purchaseOrder.financial.instalment.length);
  const initialValues = props.purchaseOrder;

  const formik = useFormik({
    initialValues,
    onSubmit: async (data) => {
      setLoading(true);
      const { itens, totalValue } = getFormItensFormik();
      const instalment = getInstalmentFormik();
      
      data.itens = itens;
      data.financial.value = totalValue;
      data.financial.instalment = instalment;

      const allValueParcel = data.financial.instalment.reduce((acc, item) => item.value + acc, 0);
      if (allValueParcel != totalValue) {
        notifyError(`A soma não confere valor das parcelas: ${allValueParcel}, valor da Compra: ${totalValue}`);
        setLoading(false);
        return;
      }

      const result = await updatePurchaseOrder(data);

      setLoading(false);
      if (!result.ok && result.message) {
        notifyError(result.message);
        return;
      }

      notifySuccess("Criado Ordem de Compra com Sucesso.");
      handleCloseModal(data);
    },
    validationSchema: createSchema()
  });

  const getInstalmentFormik = () => {

    const instalment = new Array(Number(formik.values.financial.qtdInstalment)).fill(null).map((_, i) => {
      
      return {
        installmentNumber: `${i + 1}`,
        value: parseMoneyStringToNumber(formik.values[`expectedDateValue${i}`]),
        dueDate: formik.values[`expectedDate${i}`]
      }
    });

    return instalment;
  }

  const parseMoneyStringToNumber = (value) => {
    if (typeof value == 'number') {
      return value
    }
    if (!value) {
      return 0;
    }
    if(!value.match(/R\$/gi)) {
      return parseFloat(value.replace(/\s/g, "").replace(".", "").replace(",", "."));
    }

    return parseFloat(value.replace("R$", "").replace(/\s/g, "").replace(".", "").replace(",", "."));
  }

  const getFormItensFormik = () => {
    const componentsPieceLength = window.document.querySelectorAll('#componentProduct').length;
    let totalValue = 0;
    const updatedItens = new Array(Number(componentsPieceLength)).fill(null).map((_, index) => {

      const item = formik.values[`item${index}`];
      const description = item.description ? item.description : item.label;
      const productId = item.value;
      const qtd = Number(formik.values[`qtd${index}`]);
      const value = formik.values[`value${index}`];

      totalValue += (
        (parseMoneyStringToNumber(value) * Number(qtd))
      );

      if (productId && !productId.match(/R\$/)) {
        return {
          description,
          qtd,
          value,
          productId
        }
      }
      return {
        description,
        qtd,
        value,
      }
    });

    totalValue += (parseMoneyStringToNumber(formik.values.financial.valueOfLabor) + parseMoneyStringToNumber(formik.values.financial.deliveryForecast))
      - parseMoneyStringToNumber(formik.values.financial.discountAmount);

    return { totalValue: totalValue, itens: updatedItens }
  };

  return (
    <Modal
      className='relative text-black'
      show={true}
      size="4xl"
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black dark:text-black'>
        <h2 className="text-black">Editar Ordem de Compra</h2>
      </Modal.Header>
      <Modal.Body className='text-black dark:text-black'>
        <FormikProvider value={formik}>
          <EditFormItens itens={props.purchaseOrder.itens}></EditFormItens>
          <FormEditInstalments setQtdInstalment={setQtdInstalment} instalments={props.purchaseOrder.financial.instalment} qtdInstalment={qtdInstalment}></FormEditInstalments>
        </FormikProvider>
        <div className="containerButtonPurcahseOrder">
          <ButtonWithLoader onClick={formik.handleSubmit} isLoading={loading} >Salvar</ButtonWithLoader>
        </div>
      </Modal.Body>
    </Modal>
  );
}
